import * as Yup from 'yup';
import React, {useEffect, useState, useMemo} from "react";
import {
    useForm,
    Controller,
    FormProvider
} from 'react-hook-form';
import {
    Button,
    Typography,
    Grid,
    Autocomplete,
    TextField,
    FormControlLabel,
    Radio,
    RadioGroup,
    Switch,
    //  Nuevos agregados
    Checkbox,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    TableFooter
} from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import DescriptionIcon from '@mui/icons-material/Description';
import EmailIcon from '@mui/icons-material/Email';
import {
    reset_Filter,
    reportAttendanceDownload,
    reportAttendance,
    reportMail,
    changeEnterprise_id,
    changeSeller_id,
    changeCommissionable_id,
    changeFinish_date,
    changeStart_date,
    changeTransaction_status_id,
    changeTransaction_type_id,
    reportPaginate,
    reset_data, reportAttendanceBlob,closeViewer,openViewerManually
} from "../../store/report/report";
import {useAppDispatch} from "../../store/store";
import {PdfViewerDialog} from "../../components/PdfViewerDialog/PdfViewerDialog"
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
// @ts-ignore
import {DateRangePicker, FocusedInputShape} from "react-dates";
import moment from 'moment';
import {useSelector} from "react-redux";
import {ReportSelector} from "../../store/report/report";
import { Theme, useTheme } from '@mui/material/styles';
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import AlertTitle from '@mui/material/AlertTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import DraftsIcon from "@mui/icons-material/Drafts";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {useNavigate} from "react-router-dom";
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorSharp } from '@mui/icons-material';
//Importes de interfaces
import {
    IReportePersonalizado,
    Registro,
    Colaborador,
    DatosAPI,
    DatosTransformados,

    TablaProps
} from '../../models/report';
import { authSelector } from '../../store/auth/auth';

export const Reports = () => {

    //  Para manejar los nuevos datos restructurados: IMPORTANTE
    const [dataJson, setDataJson] = useState<any | null>(null);

     //  Variables Guemez
     const navigate = useNavigate();
     const ITEM_HEIGHT = 48;
     const ITEM_PADDING_TOP = 8;
     const MenuProps = {
         PaperProps: {
             style: {
                 maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                 width: 250,
             },
         },
     };
     const getStyles=(name: string, personName: string[], theme: Theme)=> {
         return {
             fontWeight: personName.includes(name)
                 ? theme.typography.fontWeightMedium
                 : theme.typography.fontWeightRegular,
         };
     }
     const columns: GridColDef[] = [
         {
             field: 'folio', headerName: 'Folio', width: 140,
             sortable: false,
             hideable: false,
         },
         {
             field: 'fchReserva', headerName: 'Fecha', width: 120,
             sortable: false,
             hideable: false,
             renderCell: (cellValues) => {
                 const fecha = cellValues.row.fchReserva? cellValues.row.fchReserva:''
                 return <div key={`${cellValues.row.id}-${cellValues.row.intAgent}-fecha`}>{fecha.split(' ')[0]}</div>
             },
         },
         {
             field: 'seller', headerName: 'Taxista', width: 185,
             sortable: false,
             hideable: false,
             renderCell: (cellValues) => {
                 const name = cellValues.row.intAgent === 1 ? cellValues.row.commissionable_agent : cellValues.row.seller
                 return <div key={`${cellValues.row.id}-${cellValues.row.intAgent}`}>{name}</div>
             },
         },
         {
             field: 'seller_mobile_phone', headerName: 'Taxista Numero', width: 130,
             renderCell: (cellValues) => {
                 const name = cellValues.row.intAgent === 1 ? cellValues.row.seller_mobile_phone_comm : cellValues.row.seller_mobile_phone
                 return <div key={`${cellValues.row.id}-${cellValues.row.intAgent}`}>{name}</div>
             },
         },
         {
             field: 'seller_web', headerName: 'Taxista Placa', width: 120,
             renderCell: (cellValues) => {
                 const name = cellValues.row.intAgent === 1 ? cellValues.row.seller_web_comm : cellValues.row.seller_web
                 return <div key={`${cellValues.row.id}-${cellValues.row.intAgent}`}>{name}</div>
             },
         },
         {
             field: 'strTour2', headerName: 'Paquete', width: 150,
         },
         {field: 'adult', headerName: 'Adulto', width: 70, type: 'number'},
         {field: 'adult_amount', headerName: 'Total Adulto', width: 110, type: 'string'},
         {field: 'children', headerName: 'Children', width: 80, type: 'number'},
         {field: 'children_amount', headerName: 'Total Niño', width: 110, type: 'string'},
         {
             field: 'total_amount',
             headerName: 'Total Amount',
             sortable: false,
             disableColumnMenu: false,
             width: 130,
         },
         {
             field: 'transaction_status',
             headerName: 'Estatus',
             sortable: false,
             disableColumnMenu: false,
             width: 110,
         },
         {
             field: 'transaction_type',
             headerName: 'Tipo',
             sortable: false,
             disableColumnMenu: false,
             width: 110,
         }, {
             field: "",
             sortable: false,
             disableColumnMenu: true,
             width: 250,
             renderCell: (cellValues) => {
                 return (
                     <>
                     <Button
                     size="small"
                     className="btn-actions"
                     variant="contained"
                     disabled={(cellValues.row.transaction_status === 'Pagado' || !cellValues.row?.intEstado)}
                     color="primary"
                     onClick={(event) => {
                         const route = cellValues.row.transaction_type ==='Comision'? `../payment/${cellValues.row.idReserva}/${cellValues.row.intAgent}` : `../payment/${cellValues.row.idReserva}`;
                        // console.log(route)
                         navigate(route, {replace: true,state: { origin:'reports' } })

                     }}
                     startIcon={<DraftsIcon/>}
                     >
                     Pagar
                     </Button>

                     </>
                 );
             }
         },
     ];
     const theme = useTheme();
     //  Termina variables guemez

    // Selector para traer los datos del usuario logueado
    const {
        user
    } = useSelector(authSelector);


    // Departamentos estáticos para los que requieren ver todos los departamentos: 1, 45, 100
    const allDepartments = useMemo(() => [
        'Seleccionar todos',
        'Quitar todos',
        'A Y B',
        'Administracion',
        'Animacion',
        'Areas Publicas',
        'Bares',
        'Cajas WT',
        'Capitan Meseros',
        'Cocina General',
        'Cocina Mexicana',
        'Diseño Grafico',
        'Embarcaciones',
        'Grupo FXT',
        'Guia de Trolley',
        'Jimmys',
        'Mantenimiento',
        'Oficinas Cedral',
        'Oficinas PDC',
        'Operaciones',
        'Operaciones PDC',
        'PDC',
        'Programacion',
        'Redes Sociales',
        'Reservas',
        'Royal Village',    //Este no lo vi en el back
        'Seguridad',
        'Seguridad Cedral',
        'Seguridad PDC',
        'Sistemas',
        'Taller Cedral',
        'Tiendas Departamentales',
        'Tour Operador',
        'Tour Operador Cedral',
        'Tour Operador Royal',
        'Tour Operador WT',
        'Ventas PDC',
        'Ventas Riviera Maya',
        "Ventas Royal",
        'Ventas WT',
        'WT Cedral',
    ], []);

    // Departamentos disponibles calculados dinámicamente
    const availableDepartments = useMemo(() => {
        /*
            Usamos el idContador de la tabla 'tblusuario', no se usa el department_id, si no, el id único
            Actualmente los que pueden ver todos los departamentos son:
            1 - Joyner Mazariegos
            45 - Development
            100 - Natalia (RRHH)
        */
        if([1, 45, 56,100].includes(user?.id)){
            return allDepartments
        }
        return [
            user?.department_name
        ]
    }, [user?.department_id, user?.department_name])

    //  Librería Yup
    //  Esquema de validación
    const NewReportePersonalizado = Yup.object({
        department: Yup.array()
            .of(
                Yup.string().defined()  // Asegura que cada elemento sea un string definido.
            )
            .transform((value) =>
                //(value === null || value === undefined ? null : value)
                //  Excluir "Seleccionar todos" y "Quitar todos" antes de la validación
                Array.isArray(value)
                    ?   value.filter(
                        (dept) => dept !== 'Seleccionar todos' && dept !== 'Quitar todos'
                    )
                    : value
            ) // Normaliza null/undefined.
            .nullable()
            .default(null),
        name: Yup.string()
            .matches(/^[a-zA-Z\s]*$/, 'Solo se permiten letras y espacios.')
            .default(''),
        num_colab: Yup.string()
            .trim()
            // .test(
            //     'empty-or-valid',
            //     'Debe comenzar con "C" seguido de números. e.g. C111',
            //     (value) => !value || /^C\d+$/.test(value)
            // )
            .default('')
    }).required();
    //  Setear valores por defecto
    const defaultValues = useMemo(() => ({
        department: [availableDepartments[0] || ''], // Array de strings, mínimo un elemento , department: [Department[0] || ''],
        name: '',
        num_colab: ''
    }), [availableDepartments]);
    //  Métodos userForm
    const methods = useForm<IReportePersonalizado>({
        resolver: yupResolver(NewReportePersonalizado),
        defaultValues,
    });

    //  manejo de estados
    const dispatch = useAppDispatch();
    const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);
    const [departmentName, setDepartmentName] = useState<string[]>(defaultValues.department); //useState<string[]>([])
    const [activeField, setActiveField ] = useState<"departamentos" | "name" | "num_colaborador" | null>(null);

    //  Para manejar el cambio de departamentos, nombre y num colab activos
    const handleNameFocus = () => {
        setDataJson(null)               //los datos json se setean
        setValue('department',[""]);    //los departamentos se setean
        setDepartmentName([]);          //el valor en el campo departamento se setea
        setValue('num_colab', '');      //el num de colab se setea
        setActiveField("name");         //se habilita el campo name
    };

    const handleNumColabFocus = () => {
        setDataJson(null)               //los datos json se setean
        setValue('department',[""]);    //los departamentos se setean
        setDepartmentName([]);          //el valor en el campo departamento se setea
        setValue('name', '');           //el name se setea
        setActiveField("num_colaborador");  //se habilita el campo num_colaborador
    };
    //  Para manejar el cambio de departamentos
    const handleChange = (event: any, value: string[]) => {
        if (value.includes('Seleccionar todos')) {
            // Seleccionar todos los departamentos (excluye las opciones de "Seleccionar todos" y "Quitar todos")
            const allDepartments = availableDepartments.filter(
                (dept) => dept !== 'Seleccionar todos' && dept !== 'Quitar todos'
            );
            setDataJson(null);                  //los datos json se setean
            setValue('name','');                //el name se setea
            setValue('num_colab', '');           //el num de colab se setea

            setDepartmentName(allDepartments);
            setValue('department', allDepartments); // Actualiza el formulario
        } else if (value.includes('Quitar todos')) {
            setDataJson(null);                  //los datos json se setean
            setValue('name','');                //el name se setea
            setValue('num_colab', '');           //el num de colab se setea
            // Quitar todos los departamentos
            setDepartmentName([]);
            setValue('department', []); // Actualiza el formulario
        } else {
            setDataJson(null);                  //los datos json se setean
            setValue('name','');                //el name se setea
            setValue('num_colab', '');           //el num de colab se setea
            // Manejo normal de selección
            setDepartmentName(value);
            setValue(
                'department',
                value.filter(
                    (dept) => dept !== 'Seleccionar todos' && dept !== 'Quitar todos'
                )
            ); // Filtra las opciones especiales antes de actualizar el formulario
        }
    };
    //  Para "transformar" los datos que llegan de la API a una estructura deseada (la de por deptos, despues por colaborador y agrupar sus fechas)
    const transformarDatos = (data: DatosAPI): DatosTransformados => {
        const departamentos = data.departamentos;
        const quincena = data.quincena

        const resultado: DatosTransformados = {
          quincena,
          departamentos: {},
        };

        // Iterar sobre cada departamento
        Object.keys(departamentos).forEach((departamento) => {
          const colaboradores: { [key: string]: Colaborador } = {};

          departamentos[departamento].forEach((registro) => {
            const { strNum_colaborador, strColaborador, fchDate, strHora_entrada, strHora_salida } = registro;

            // Si el colaborador no existe aún, inicialízalo
            if (!colaboradores[strNum_colaborador]) {
              colaboradores[strNum_colaborador] = {
                strNum_colaborador,
                strColaborador,
                fechas: [],
              };
            }

            // Agrega la fecha y horas al colaborador correspondiente
            colaboradores[strNum_colaborador].fechas.push({
              fchDate,
              strHora_entrada,
              strHora_salida,
            });
          });

          // Convierte el objeto de colaboradores en un arreglo
          resultado.departamentos[departamento] = Object.values(colaboradores);
        });

        return resultado;
    };

    //  Variables a usar de useSelector
    const {
        meta: {
            current_page,
            per_page,
            total
        },
        data,
        search,
        loadingReport,
        enterprise_id,
        seller_id,
        commissionable_id,
        start_date,
        finish_date,
        transaction_type_id,
        transaction_status_id,
        urlPdf,
        openViewer,
        openViewerManually
    } = useSelector(ReportSelector);

    //  Desestructuración de métodos para obtener manejadores
    const {
        reset,
        watch,
        setValue,
        handleSubmit,
        formState: {isSubmitting, errors}
    } = methods

    //  Si el submit es correcto en sus datos
    const onSubmit = async (data: IReportePersonalizado) => {
        if(data?.department){
            //  Esperamos la data
            const result = await dispatch(reportAttendance({
                date_end: finish_date,
                date_start: start_date,
                department: data.department,
                name: data.name,
                id: data.num_colab,
            }))

            //  Si se obtuvieron correctamente
            if(reportAttendance.fulfilled.match(result)){
                //  Almacenamos la data del payload
                const jsonResponse = result.payload.data;
                //  @ts-ignore
                //  transformamos los datos de como viene de la API al nuevo formato.
                const tabla = transformarDatos(jsonResponse);
                //const tabla = transformDataForTable(jsonResponse);      //Este estaba descomentado || Para la antigua versión de la tabla
                // Para setear en dataJson y tener dinamismo
                setDataJson(tabla);
            }else{
                console.error("Error al obtener datos:", result.error?.message);
            }
        }
    };
    //Si el submit no es correcto en sus datos o cualquier error
    const onError = (errors: any) => {
        console.error("Errores", errors);
    }

    //  Tabla horarios de entrada - salida  || IMPORTANTE NO ELIMINAR dado que es el componente que pinta la tabla
    const TablaHorario: React.FC<TablaProps> = ({ datos }) => {
        const [search, setSearch] = useState(""); // Estado para el buscador
        const [page, setPage] = useState(0);      // Página actual
        const [rowsPerPage, setRowsPerPage] = useState(5);  //  Fila por página

        const filteredDepartamentos = Object.entries(datos.departamentos).reduce(
            (acc, [departamento, registros]) => {
              const registrosFiltrados = registros.filter((registro) =>
                `${registro.strNum_colaborador} ${registro.strColaborador}`
                  .toLowerCase()
                  .includes(search.toLowerCase())
              );

              if (registrosFiltrados.length > 0) {
                acc[departamento] = registrosFiltrados;
              }

              return acc;
            },
            {} as { [departamento: string]: Registro[] }
          );

        const flattenedData = Object.entries(filteredDepartamentos).flatMap(
            ([departamento, registros]) =>
            registros.map((registro) => ({ ...registro, departamento }))
        );

        //Datos paginados
        const paginatedData = flattenedData.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );

        const handleChangePage = (event: unknown, newPage: number) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reinicia la página al cambiar filas por página
        };

        return (
            <Box>
                {/* Encabezado con la quincena */}
                    {
                        hasAccessToUploadReport &&        <Typography variant="h6" sx={{ mb: 2 }}>
                            Fecha correspondiente al: {datos.quincena}
                        </Typography>

                    }
                    {
                        hasAccessToUploadReport &&            <TextField
                            label="Buscar colaborador"
                            variant="outlined"
                            fullWidth
                            sx={{ mb: 4 }}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)} // Actualizar el texto del buscador
                        />
                    }
                {/* Buscador */}

                {/* Tabla */}
                <Table>
                    <TableHead>
                    <TableRow>
                        <TableCell style={{ fontWeight: "800" }}>Departamento</TableCell>
                        <TableCell style={{ fontWeight: "800" }}>Colaborador</TableCell>
                        <TableCell style={{ fontWeight: "800" }}>Fechas (entrada - salida)</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {paginatedData.map((registro, idx) => (
                        <TableRow key={`${registro.departamento}-${idx}`}>
                        <TableCell>{registro.departamento}</TableCell>
                        <TableCell>
                            {registro.strNum_colaborador} - {registro.strColaborador}
                        </TableCell>
                        <TableCell>
                            {registro.fechas.map((fecha, fechaIdx) => (
                            <Box key={fechaIdx}>
                                <Typography variant="body2">
                                {fecha.fchDate}: {fecha.strHora_entrada} - {fecha.strHora_salida}
                                </Typography>
                            </Box>
                            ))}
                        </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                    <TableFooter>
                    <TableRow>
                        <TablePagination
                            sx={{
                                '.MuiTablePagination-toolbar': {
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    alignItems: { xs: 'flex-start', sm: 'center' },
                                },
                            }}
                        rowsPerPageOptions={[5, 10, 25]}
                        count={flattenedData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage="Filas por página"
                        />
                    </TableRow>
                    </TableFooter>
                </Table>
            </Box>
        );

        // Otra formato de tabla sin buscador y con departamentos separados
        // const { quincena, departamentos } = datos;

        // return (
        //   <Grid container spacing={2}>
        //     {/* Título de la tabla */}
        //     <Grid item xs={12}>
        //       <Typography variant="h6" align="center" style={{ fontWeight: 600 }}>
        //         Fecha correspondiente al: {quincena}
        //       </Typography>
        //     </Grid>

        //     {/* Tabla para cada departamento */}
        //     {Object.entries(departamentos).map(([departamento, colaboradores]) => (
        //       <Grid item xs={12} key={departamento} style={{ marginBottom: "3rem" }}>
        //         <Typography variant="h6" align="center" style={{ fontWeight: 600 }} >
        //           {departamento}
        //         </Typography>
        //         <TableContainer component={Paper} >
        //           <Table>
        //             <TableHead>
        //               <TableRow>
        //                 {/* Encabezado: Fechas */}
        //                 <TableCell style={{ fontWeight: 600 }}>Colaborador</TableCell>
        //                 {colaboradores[0]?.fechas.map((fecha, index) => (
        //                   <TableCell key={index} align="center" style={{ fontWeight: 600 }}>
        //                     {fecha.fchDate}
        //                   </TableCell>
        //                 ))}
        //               </TableRow>
        //             </TableHead>
        //             <TableBody>
        //               {/* Filas por colaborador */}
        //               {colaboradores.map((colaborador) => (
        //                 <TableRow key={colaborador.strNum_colaborador}>
        //                   <TableCell >
        //                     <Typography variant="subtitle2">
        //                       {colaborador.strNum_colaborador}
        //                     </Typography>
        //                     <Typography variant="body2" style={{ textTransform: "capitalize" }}>
        //                       {colaborador.strColaborador}
        //                     </Typography>
        //                   </TableCell>
        //                   {/* Celdas con entrada/salida */}
        //                   {colaborador.fechas.map((fecha, index) => (
        //                     <TableCell key={index} align="center">
        //                       <Typography variant="body2">
        //                         {fecha.strHora_entrada}
        //                       </Typography>
        //                       <Typography variant="body2">
        //                         {fecha.strHora_salida}
        //                       </Typography>
        //                     </TableCell>
        //                   ))}
        //                 </TableRow>
        //               ))}
        //             </TableBody>
        //           </Table>
        //         </TableContainer>
        //       </Grid>
        //     ))}
        //   </Grid>
        // );
    };


    useEffect(() => {
        // @ts-ignore
        dispatch(changeSeller_id(0))
        // @ts-ignore
        dispatch(changeCommissionable_id(0))
        dispatch(reset_Filter())
        //  Seteamos la fecha actual en ambos
        if(!start_date){
            dispatch(changeStart_date(moment().format('YYYY-MM-DD')));
        }
        if(!finish_date){
            dispatch(changeFinish_date(moment().format('YYYY-MM-DD')));
        }
    }, [start_date, finish_date, dispatch, user]);
    const [openDialog, setOpenDialog] = useState(false);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const isMobile = window.innerWidth <= 768;
    const hasAccessToUploadReport = [1, 45, 56,100].some(
        (value) => value === user.id
    );

    // @ts-ignore
    return (
        <>
            <div className="content-panel">
                <div>
                    <Typography className={"filterByClass"} variant="overline" display="block" gutterBottom>
                        Filtrar por:
                    </Typography>
                    <FormProvider {...methods}>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <Grid container spacing={2} style={{gridGap: '15px 0'}}>
                                <Grid item xs={12}>
                                    <div className="cont-center">
                                        <div>
                                            <Typography className="titulo-reportes" variant="h6" gutterBottom component="div">Rango
                                                de Fecha</Typography>
                                        </div>
                                        <DateRangePicker
                                            startDate={start_date !== null ? moment(start_date) : start_date}   //    start_date ? moment(start_date, 'YYYY-MM-DD') : moment()
                                            endDate={finish_date !== null ? moment(finish_date) : finish_date}  //    finish_date ? moment(finish_date, 'YYYY-MM-DD') : moment()
                                            startDateId='daterangepicker_start_date'
                                            displayFormat='DD/MM/YYYY'
                                            startDateAriaLabel='Fecha de Entrada'
                                            minimumNights={0}
                                            numberOfMonths={isMobile?1:2} // mostrar solo un mes en móvil
                                            isOutsideRange={() => false}
                                            hideKeyboardShortcutsPanel
                                            endDateId='daterangepicker_end_date'
                                            onDatesChange={(value: { startDate: moment.MomentInput; endDate: moment.MomentInput; }) => {
                                                if(moment.isMoment(value.startDate) && start_date !== value.startDate.format('YYYY-MM-DD')) {
                                                    dispatch(changeStart_date(value.startDate.format('YYYY-MM-DD')));
                                                    dispatch(reset_data());
                                                }
                                                if(moment.isMoment(value.endDate) && finish_date !== value.endDate.format('YYYY-MM-DD')){
                                                    dispatch(changeFinish_date(value.endDate.format('YYYY-MM-DD')));
                                                    dispatch(reset_data());
                                                }
                                            }}
                                            focusedInput={focusedInput}
                                            onFocusChange={(focusedInput: FocusedInputShape | null) => {
                                                setFocusedInput(focusedInput)
                                            }
                                            }
                                        />

                                    </div>
                                </Grid>


                                {
                                    (hasAccessToUploadReport &&!isMobile) &&     <Grid item xs={12}>
                                        <div className="cont-center">
                                            <div>
                                                <Typography
                                                    gutterBottom
                                                    component="div"
                                                    style={{
                                                        fontWeight: "600"
                                                    }}
                                                >Seleccionar uno de los tres siguientes filtros:  </Typography>
                                            </div>
                                            <div>
                                                <Typography
                                                    gutterBottom
                                                    component="div"
                                                    style={{
                                                        fontWeight: "100",
                                                    }}
                                                >*Puede dejar en blanco los tres campos </Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                }

                                {
                                    (hasAccessToUploadReport &&!isMobile) &&        <Grid item xs={10} md={5}>

                                        <div className="cont-center">
                                            <div>
                                                <Typography className="titulo-reportes" variant="h6" gutterBottom
                                                            component="div">Departamentos</Typography>
                                            </div>
                                            <Autocomplete
                                                multiple
                                                id="tags-standard"
                                                options={availableDepartments}
                                                value={departmentName}
                                                onChange={handleChange}
                                                disableCloseOnSelect // Permite mantener abierto el menú mientras seleccionas opciones
                                                groupBy={(option) =>
                                                    // Agrupa las opciones: "Acciones" (para Seleccionar/Quitar todos) y "Departamentos" (resto)
                                                    option === 'Seleccionar todos' || option === 'Quitar todos' ? 'Acciones' : 'Departamentos'
                                                }
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            checked={selected} // Muestra el estado de selección
                                                            style={{ marginRight: 8 }}
                                                        />
                                                        {option}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        placeholder="Departamentos"
                                                        error={!!errors.department}
                                                        helperText={errors.department?.message}
                                                    />
                                                )}
                                                renderGroup={(params) => (
                                                    <div key={params.key}>
                                                        <div style={{ fontWeight: 'bold', padding: '8px 16px', background: '#f5f5f5' }}>
                                                            {params.group}
                                                        </div>
                                                        <div>{params.children}</div>
                                                    </div>
                                                )}
                                                renderTags={(selected, getTagProps) => {
                                                    // Si hay más de 1 selección, muestra un texto resumido
                                                    if (selected.length > 3) {
                                                        return (
                                                            <Typography variant="body2" color="textSecondary">
                                                                Seleccionados ({selected.length})
                                                            </Typography>
                                                        );
                                                    }
                                                    // Caso normal: muestra el nombre de la selección si hay solo uno
                                                    return selected.map((option, index) => (
                                                        <Chip
                                                            label={option}
                                                            {...getTagProps({ index })}
                                                        />
                                                    ));
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                }
                                {/*Filtro Departamentos*/}

                                {
                                    (hasAccessToUploadReport  &&!isMobile) && <Grid item xs={10} md={4}>
                                        <div>
                                            <Typography className="titulo-reportes" variant="h6" gutterBottom
                                                        component="div">Nombre</Typography>
                                        </div>
                                        <TextField
                                            {...methods.register('name')}
                                            style={{width:'100%'}}
                                            //value={formValues?.name_text_field}
                                            id="name_text_field"
                                            label="Nombre"
                                            error={!!errors.name}
                                            helperText={errors.name?.message}
                                            onFocus={handleNameFocus}
                                            onBlur={() => setActiveField(null)}
                                            disabled={activeField !== null && activeField !== "name"}
                                        />
                                    </Grid>
                                }
                                {/*Filtro Nombre*/}
                                {
                                    (hasAccessToUploadReport && !isMobile) && <Grid item xs={10} md={3}>
                                        <Typography className="titulo-reportes" variant="h6" gutterBottom
                                                    component="div">N° Colaborador</Typography>
                                        <TextField
                                            {...methods.register('num_colab')}
                                            style={{width:'100%'}}
                                            id="id_number"
                                            label="N° Colab"
                                            //type="number"
                                            error={!!errors.num_colab}
                                            helperText={errors.num_colab?.message}
                                            onFocus={handleNumColabFocus}
                                            onBlur={() => setActiveField(null)}
                                            disabled={activeField !== null && activeField !== "num_colaborador"}
                                        />
                                    </Grid>
                                }

                                {/*Filtro Número de Colaborador*/}



                                {/*<Grid item xs={4}>*/}
                                {/*    <div className="cont-center">*/}
                                {/*        <div>*/}
                                {/*            <Typography className="titulo-reportes" variant="h6" gutterBottom component="div">Estatus*/}
                                {/*                de transacción</Typography>*/}
                                {/*        </div>*/}
                                {/*        <RadioGroup*/}
                                {/*            aria-labelledby="demo-controlled-radio-buttons-group"*/}
                                {/*            name="controlled-radio-buttons-group"*/}
                                {/*            defaultValue=""*/}
                                {/*            value={transaction_status_id}*/}
                                {/*            onChange={(event, value) => {*/}
                                {/*                dispatch(changeTransaction_status_id(parseInt(value)))*/}
                                {/*            }}*/}
                                {/*        >*/}
                                {/*            <FormControlLabel value="5" control={<Radio/>} label="Pendiente"/>*/}
                                {/*            <FormControlLabel value="6" control={<Radio/>} label="Pagado"/>*/}
                                {/*            <FormControlLabel value="" control={<Radio/>} label="Todo"/>*/}
                                {/*        </RadioGroup>*/}
                                {/*    </div>*/}
                                {/*</Grid>*/}
                            </Grid>

                            {/*BOTONES*/}
                            <div className={"gridButtons"} style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'flex-end',
                                gap: '8px',
                            }}>
                                {
                                     !isMobile &&          <Button
                                        type='submit'
                                        variant="contained"
                                        sx={{
                                            mb: 2,
                                            mt: 4,
                                            flex: '1 1 auto',
                                            minWidth: '200px',
                                        }}
                                        startIcon={<DescriptionIcon/>}
                                    >
                                        Ver  Asistencia
                                    </Button>
                                }


                                <Button
                                    type='submit'
                                    variant="contained"
                                    onClick={() => {
                                        dispatch(reportAttendanceBlob({
                                            date_start: start_date,
                                            date_end: finish_date,
                                            department: methods.getValues('department') || [""],
                                            id: methods.getValues('num_colab'),
                                            name: methods.getValues('name'),
                                        }));
                                    }}
                                    sx={{
                                        mb: 2,
                                        mt: 4,
                                        flex: '1 1 auto',
                                        minWidth: '200px',
                                    }}
                                    startIcon={<DescriptionIcon/>}
                                >
                                    Abrir reporte
                                </Button>

                                {/*Para el boton de descarga*/}
                                {
                                    dataJson !== null && <Button onClick={() => {
                                        dispatch(reportAttendanceDownload({
                                            date_start: start_date,
                                            date_end: finish_date,
                                            department: methods.getValues('department') || [""],
                                            id: methods.getValues('num_colab'),
                                            name: methods.getValues('name'),
                                        }));
                                    }} variant="contained" sx={{ mb: 2,
                                        mt: 4,
                                        flex: '1 1 auto',
                                        minWidth: '200px',background:'#1D6F42',"&:hover": {
                                            backgroundColor: '#1D6F42',
                                        }}} startIcon={<FileDownloadIcon/>}>Descargar Asistencias</Button>
                                }
                                {
                                    !isMobile &&   <Button
                                        onClick={() => {
                                            dispatch(reset_Filter());
                                            setDepartmentName(defaultValues.department) //setDepartmentName([])
                                            //setFormValues({name_text_field: "",id_number: 0})
                                            dispatch(changeStart_date(moment().format('YYYY-MM-DD')))
                                            dispatch(changeFinish_date(moment().format('YYYY-MM-DD')))
                                            reset() //Reset en Yup
                                            setDataJson(null);
                                            // @ts-ignore
                                        }}
                                        variant="contained"
                                        sx={{
                                            mb: 2,
                                            mt: 4,
                                            background: '#d32d20',
                                            flex: '1 1 auto',
                                            minWidth: '200px',
                                            "&:hover": { backgroundColor: '#d32d20' }
                                        }}
                                        startIcon={<RestartAltIcon/>}>
                                        Reiniciar Filtros
                                    </Button>
                                }

                            </div>



                            {/*TABLA DE DATOS*/}
                            {    
                                (dataJson) ?

                                    <TablaHorario datos={dataJson} />

                                    :
                                    <Stack sx={{width: '100%'}} spacing={2}>
                                        <Alert severity="warning">
                                            <AlertTitle>No se encontraron datos.</AlertTitle>
                                        </Alert>
                                    </Stack>
                            }
                        </form>

                    </FormProvider>



                </div>




            </div>
        </>
    )
}

export default Reports
